import { useState } from "react";
import { api } from "../../services/apiService";
import { set } from "date-fns";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";

export default function useTrem() {
  const [trens, setTrens] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    type: 'confirm',
    message: '',
    onConfirm: null
  });

  const listarTrens = async (page = 1, pageSize = 20) => {
    try {
      const response = await api.trem.getAll(page, pageSize);

      const payload = response?.data || response || {};

      setTotalCount(payload.totalCount || 0);
      const items = payload.items || data;
      setTrens(
        items.map(t => ({
          id: t.id,
          nome: t.nomeCodigo,
          identificacao: t.nomeCodigo,
          frotaId: t.frotaId,
          identificadorTrem: t.identificadorTrem,
          quantidadeCarros: t.quantidadeCarros
        }))
      );
    } catch (error) {
      alert(error.response.data.message);
    }
  };

  const excluirTrem = async (id, nome, page) => {
    setModalConfig({
      type: 'confirm',
      message: `Deseja realmente excluir o trem "${nome}"?`,
      onConfirm: async () => {
        try {
          await api.trem.delete(id);

          setModalConfig({
            type: 'success',
            message: 'Trem excluído com sucesso!',
            onConfirm: null
          });
                
          listarTrens(page);
          setTimeout(() => setShowModal(false), 2000);

        } catch (error) {
          setModalConfig({
            type: 'error',
            message: error.response?.data?.message || 'Erro ao excluir trem',
            onConfirm: null
          });
        }
      }
    });
    setShowModal(true);
  };
  return { 
    trens, 
    totalCount, 
    listarTrens, 
    excluirTrem,
    ModalComponent: (
      <ConfirmModal
        show={showModal}
        type={modalConfig.type}
        message={modalConfig.message}
        onConfirm={modalConfig.onConfirm}
        onClose={() => setShowModal(false)}
      />
    )
  };
}
